<template>
  <div class="results">
    <div class="shadow-divide scroll-border-dom"></div>
    <div class="results-wrap">
      <Breadcrumb separator=">">
        <BreadcrumbItem><router-link to="/">{{$t('nav.home')}}</router-link></BreadcrumbItem>
        <BreadcrumbItem><router-link :to="{name: 'myAccount'}">个人中心</router-link></BreadcrumbItem>
        <BreadcrumbItem><router-link :to="{name: 'RulesDecide'}">{{$t('rulesDecide.title')}}</router-link></BreadcrumbItem>
        <BreadcrumbItem>证书列表</BreadcrumbItem>
      </Breadcrumb>
      <div class="results-content">
        <List ref="list" class="r-main" :mh="mh"></List>
      </div>
    </div>
  </div>
</template>

<script>
import List from './zh-CN/CertList'
export default {
  name: 'RulesDecideCert',
  components: { List },
  data () {
    return {
      mh: 0
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.setSidebarHeight()
    })
  },
  methods: {
    setSidebarHeight () {
      let resultDom = document.querySelector('.results')
      let footer = document.querySelector('footer')
      let resultMinHeight = (this._h.getWinHeight() - Math.abs(this._h.getScrollTop() - Math.abs(this._h.getOffset(resultDom).top) - this._h.getOuterElSize(footer).height - 18))
      resultDom.style.minHeight = resultMinHeight + 'px'
      this.mh = resultMinHeight - 200
    }
  }
}
</script>
<style scoped>
  .results{
    position: relative;
    padding: 15px 0 25px;
    background-color: #f8f8f8;
  }
  .results-wrap{
    width:1400px;
    margin: 0 auto;
    padding-bottom: 20px;
  }
  .shadow-divide{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    box-shadow: 0 2px 4px 0 rgba(223,223,223,0.50);
    z-index: 1;
    height: 5px;
    background-color: #fff;
  }
  .ivu-breadcrumb{
    margin: 12px 0 30px;
    /*font-size: 11px;*/
    font-size: 13px;
  }
  .ivu-breadcrumb .ivu-breadcrumb-item-link,
  .ivu-breadcrumb >>> a{
    color: #999;
  }
  .ivu-breadcrumb >>> a:hover{
    color: #1F8AFD;
    text-decoration: none;
    box-shadow: none;
  }
  .ivu-breadcrumb >>> a:after{
    width: 0;
    height: 0;
  }
  .ivu-breadcrumb > span:last-child{
    color: #1F8AFD;
    font-weight: normal;
  }
  .ivu-breadcrumb >>> .ivu-breadcrumb-item-separator{
    margin: 0 2px;
  }
  .results-content{
    position: relative;
  }
  .r-main{}
</style>




// WEBPACK FOOTER //
// src/components/RulesDecide/Cert.vue